import { Link } from "react-router-dom";

const LINKS = [
  { to: "/pricing", label: "Pricing & Plans", testid: "footer-link-pricing" },
  { to: "/terms", label: "Terms & Conditions", testid: "footer-link-terms" },
  { to: "/privacy", label: "Privacy Policy", testid: "footer-link-privacy" },
  { to: "/refund", label: "Cancellation & Refund", testid: "footer-link-refund" },
  { to: "/shipping", label: "Shipping Policy", testid: "footer-link-shipping" },
  { to: "/contact", label: "Contact Us", testid: "footer-link-contact" },
  { to: "/grievance", label: "Grievance / Support", testid: "footer-link-grievance" },
];

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <strong>Barter India</strong>
          <span className="muted small">Trade More. Pay Less. Grow Together.</span>
        </div>
        <nav className="footer-nav" aria-label="Footer">
          {LINKS.map(({ to, label, testid }) => (
            <Link key={to} to={to} data-testid={testid}>{label}</Link>
          ))}
        </nav>
        <div className="footer-legal muted small">
          © {year} Barter India. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
